import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the ImgcostsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-imgcosts',
  templateUrl: 'imgcosts.html',
})
export class ImgcostsPage {
  idx: number;
  imagepath: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.idx = navParams.get('index')
    this.imagepath = navParams.get('image')

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ImgcostsPage');
  }


  deleteImg() {
    var _that = this
    // this.gn._Post('/api/gn/deletephoto', { imgpath: this.gn.crypt(this.imagepath) }, function (_data) {
    // console.log(_data, 'daj da vidam data')
    var _cb = _that.navParams.get('cb')
    if (_cb != null) {
      _cb(_that.idx, '/')
    }
    _that.navCtrl.pop()
    //   })
  }

}



// WEBPACK FOOTER //
// ./src/pages/costs/imgcosts/imgcosts.ts